import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UsageSnapshot } from './models/usage-snapshot.model';

@Injectable({ providedIn: 'root' })
export class UsageSnapshotService {
  public getOrganizationMonthlyUsageSnapshot() {
    const url = `${environment.apiConfig.url}/organization-usage-snapshot`;
    return this.http.get<UsageSnapshot>(url);
  }

  constructor(private http: HttpClient) {}
}
